/**
 * Offline fixture generated from the same catalog as the API: the official Dr. Calorie menu.
 * IDs here are fixture keys. Production IDs are database-owned.
 */
import type { MenuCategoryOut, MenuItemOut, MenuOut, RestaurantOut, ReviewOut } from '@/types/api';
import catalog from './demo-menu.generated.json';

const source = catalog.restaurant;

export const MOCK_RESTAURANT: RestaurantOut = {
  id: 1, slug: source.slug, name_fa: source.name_fa,
  short_description_fa: source.short_description_fa,
  primary_color: '#1A5F25', secondary_color: '#3BB44B',
  logo_url: source.logo_url,
  cover_media_url: source.cover_url,
  phone: null, address_fa: source.address_fa, instagram_url: null, active: true, guest_access: 'open',
};

export const MOCK_ITEMS: MenuItemOut[] = catalog.items.map((seed, index) => ({
  id: seed.id, category_id: seed.category_id, name_fa: seed.name,
  short_description_fa: seed.short, full_description_fa: seed.full,
  price_irr: seed.price, ingredients: seed.ingredients, taste_profile: seed.taste,
  preparation_method: seed.method, portion_description: seed.portion,
  serves_count: seed.serves, allergen_tags: seed.allergens, dietary_tags: seed.dietary,
  spice_level: seed.spice, available: seed.available, featured: seed.featured,
  popularity_label: seed.label, pairing_item_ids: seed.pairings,
  seasonal_offer: Boolean(seed.seasonal), seasonal_label: seed.seasonal,
  preparation_minutes: seed.minutes, sort_order: index,
  details: { ...seed.details, source: 'demo_curated' } as MenuItemOut['details'],
  // Some dishes have no photo on the official menu; none is invented for them.
  media: seed.photo ? [{
    id: seed.id * 10 + 1, type: 'image',
    url: seed.photo, thumbnail_url: seed.photo,
    alt_fa: `عکس ${seed.name} در منوی رسمی`, sort_order: 0,
  }] : [],
}));

export const MOCK_ITEMS_BY_ID: Record<number, MenuItemOut> = Object.fromEntries(
  MOCK_ITEMS.map((item) => [item.id, item]),
);

export const MOCK_CATEGORIES: MenuCategoryOut[] = catalog.categories.map((category, index) => ({
  ...category, sort_order: index,
  items: MOCK_ITEMS.filter((item) => item.category_id === category.id),
}));

export const MOCK_MENU: MenuOut = { restaurant: MOCK_RESTAURANT, categories: MOCK_CATEGORIES };

/**
 * No guest reviews are invented for a real restaurant's dishes. Reviews appear
 * only when a guest of an actual (demo) order writes one.
 */
export function mockReviewsForItem(_itemId: number): ReviewOut[] {
  return [];
}

export const MOCK_REVIEWS: ReviewOut[] = [];
